import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";

export async function fetchData(
  url: string,
  body: any,
  method: "POST" | "GET",
  controllerRef?: React.MutableRefObject<AbortController | null>,
  headers?: Record<string, string>
) {
  const tenantId = LocalStorageService.getItem(LocalStorageKeys.TenantId);
  const storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId);
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);
  const sessionId = LocalStorageService.getItem(LocalStorageKeys.SessionId);
  const locale = LocalStorageService.getItem(LocalStorageKeys.LanguageCode);
  const countryCode = LocalStorageService.getItem(LocalStorageKeys.CountryCode);

  const defaultHeaders = {
    "Content-Type": "application/json",
    "Tenant-Id": tenantId,
    "Store-Id": storeId,
    "Device-Id": deviceId,
    "Session-Id": sessionId,
    "Accept-Language": locale,
    "x-delivery-country": countryCode,
  };

  const init = {
    ...(controllerRef && controllerRef.current
      ? { signal: controllerRef.current.signal }
      : {}),
    body: JSON.stringify(body),
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    method,
  };

  return fetch(url, init);
}
